import styled from 'styled-components';

import { TooltipWrapper } from '../../../../CustomizationForm/CustomizationFormCheckbox/Wrapper';

const Wrapper = styled.div`
  margin: -8px 0 25px;
  ${TooltipWrapper} {
    width: 230px;
    margin: 0 auto 0 0;
  }
`;

export default Wrapper;
